import {
  faAdd,
  faAddressCard,
  faAirConditioner,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAppleWhole,
  faArrowRightLong,
  faArrows,
  faBabyCarriage,
  faBadminton,
  faBanSmoking,
  faBaseballBatBall,
  faBasketballHoop,
  faBasketShopping,
  faBath,
  faBellConcierge,
  faBenchTree,
  faBicycle,
  faBlanket,
  faBolt,
  faBook,
  faBookOpenCover,
  faBottleWater,
  faBowArrow,
  faBowlHot,
  faBowlingBallPin,
  faBox,
  faBraille,
  faBriefcase,
  faBullseyeArrow,
  faBurgerFries,
  faBurrito,
  faCalendar,
  faCalendarCheck,
  faCameraCctv,
  faCampfire,
  faCar,
  faCards,
  faCarGarage,
  faChairOffice,
  faChampagneGlass,
  faChampagneGlasses,
  faCheck,
  faCheckCircle,
  faChurch,
  faCircle,
  faCircleDollar,
  faCircleExclamation,
  faClock,
  faClothesHanger,
  faCoffeePot,
  faComment,
  faCompactDisc,
  faComputerSpeaker,
  faConciergeBell,
  faContactBook,
  faCookie,
  faCreditCard,
  faCreditCardBlank,
  faCroissant,
  faCupStrawSwoosh,
  faDice,
  faDoNotEnter,
  faDumbbell,
  faEarListen,
  faElevator,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFamily,
  faFax,
  faFeather,
  faFileCertificate,
  faFileInvoiceDollar,
  faFireBurner,
  faFireExtinguisher,
  faFireplace,
  faFishingRod,
  faFlatbreadStuffed,
  faFlowerTulip,
  faGift,
  faGlassWaterDroplet,
  faGlobe,
  faGolfBallTee,
  faGolfFlagHole,
  faHand,
  faHandHoldingMedical,
  faHandshake,
  faHandSparkles,
  faHandsPraying,
  faHatChef,
  faHeadSideMask,
  faHeat,
  faHorse,
  faHotTubPerson,
  faHouseMedical,
  faImages,
  faInfoCircle,
  faKitMedical,
  faLeafHeart,
  faLips,
  faLock,
  faLoveseat,
  faMagnifyingGlass,
  faMap,
  faMapMarkerAlt,
  faMartiniGlass,
  faMartiniGlassCitrus,
  faMaskFace,
  faMaskSnorkel,
  faMicrophoneStand,
  faMinus,
  faMobileScreenButton,
  faMoneyBillWave,
  faMoneyFromBracket,
  faNewspaper,
  faOven,
  faPalette,
  faPancakes,
  faPanFood,
  faPencil,
  faPeopleArrows,
  faPeoplePants,
  faPersonCarryBox,
  faPersonHiking,
  faPersonSeatReclined,
  faPersonSign,
  faPersonSkiing,
  faPaw,
  faPersonSwimming,
  faPhoneIntercom,
  faPopcorn,
  faPotFood,
  faPrint,
  faPumpMedical,
  faRacquet,
  faRingsWedding,
  faRollerCoaster,
  faRouter,
  faSailboat,
  faSalad,
  faSeal,
  faSensorFire,
  faShieldCheck,
  faShieldVirus,
  faShop,
  faShoppingBasket,
  faSignalStream,
  faSink,
  faSirenOn,
  faSmoking,
  faSoup,
  faSpa,
  faSparkles,
  faSprayCan,
  faSquareParking,
  faStar,
  faSuitcase,
  faSun,
  faSunCloud,
  faTablePicnic,
  faTableTennisPaddleBall,
  faTag,
  faTaxi,
  faTeddyBear,
  faTemperatureHigh,
  faTennisBall,
  faThermometer,
  faTicket,
  faToilet,
  faTrashCan,
  faTv,
  faTvMusic,
  faUmbrellaBeach,
  faUniversalAccess,
  faUniversity,
  faUserDoctor,
  faUtensils,
  faVanShuttle,
  faVault,
  faVirusCovidSlash,
  faVolumeSlash,
  faWashingMachine,
  faWaterLadder,
  faWheelchair,
  faWifi,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faClose,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faChildReaching,
  faMoon,
  faUsers,
  faUser,
  faBed,
  faRefresh,
} from '@fortawesome/pro-solid-svg-icons';

import { FaIconName } from './types';

const FA_ICONS: Record<FaIconName, IconDefinition> = {
  '24-hour-check-in': faBellConcierge,
  '24-hour-front-desk': faBellConcierge,
  '24-hour-security': faShieldCheck,
  'access-to-healthcare-professionals': faUserDoctor,
  'accessible-parking': faUniversalAccess,
  add: faAdd,
  'adults-only': faPeoplePants,
  aerobics: faDumbbell,
  'air-conditioning': faAirConditioner,
  'airport-shuttle': faVanShuttle,
  'all-inclusive-meals': faUtensils,
  'all-rooms-disinfected-daily': faSprayCan,
  'angle-down': faAngleDown,
  'angle-left': faAngleLeft,
  'angle-right': faAngleRight,
  'angle-up': faAngleUp,
  archery: faBowArrow,
  'arrow-down': faArrowDown,
  'arrow-left': faArrowLeft,
  'arrow-right': faArrowRight,
  'arrow-right-long': faArrowRightLong,
  'arrow-up': faArrowUp,
  arrows: faArrows,
  'atm-on-site': faMoneyFromBracket,
  'audio-visual-equipment-rental': faComputerSpeaker,
  'auditory-guidance': faEarListen,
  'baby-safety-gates': faBabyCarriage,
  badminton: faBadminton,
  'baggage-storage': faSuitcase,
  'banquet-rooms': faChampagneGlasses,
  bar: faMartiniGlass,
  'bar-crawls': faChampagneGlasses,
  basket: faShoppingBasket,
  bathhouse: faWaterLadder,
  'bathroom-emergency-pull-cord': faUniversalAccess,
  'bbq-facilities': faFireBurner,
  beach: faUmbrellaBeach,
  'beach-area-private': faUmbrellaBeach,
  'beach-chairs-loungers': faPersonSeatReclined,
  beachfront: faUmbrellaBeach,
  'beauty-services': faLips,
  bed: faBed,
  'bicycle-rental': faBicycle,
  'bike-tour': faBicycle,
  'bike-tours': faBicycle,
  'billiards-pool-table': faDice,
  bingo: faDice,
  'board-games-puzzles': faDice,
  boating: faSailboat,
  'body-thermometer': faThermometer,
  'books-dvds-music-for-kids': faBook,
  'bottled-water': faBottleWater,
  bowling: faBowlingBallPin,
  'breakfast-buffet': faPancakes,
  'breakfast-complimentary': faPancakes,
  'breakfast-continental': faCroissant,
  'breakfast-in-the-room': faPancakes,
  'breakfast-takeaway-containers': faBox,
  'business-center': faBriefcase,
  'buzzer-wireless-intercom': faPhoneIntercom,
  calendar: faCalendar,
  'calendar-check': faCalendarCheck,
  canoeing: faSailboat,
  'car-for-hire': faCar,
  'car-rental': faCar,
  'carbon-monoxide-detector': faSensorFire,
  'carbon-monoxide-sources': faHeat,
  'cashless-payment-accepted': faCreditCard,
  casino: faCards,
  'cctv-in-common-areas': faCameraCctv,
  'cctv-outside-property': faCameraCctv,
  chapel: faChurch,
  check: faCheck,
  'check-circle': faCheckCircle,
  'child-friendly-buffet': faPancakes,
  'child-reaching': faChildReaching,
  'childcare-services': faChildReaching,
  'childrens-meals': faChildReaching,
  'childrens-tv-channels': faTv,
  'chocolate-cookies': faCookie,
  'cleaning-chemicals-used-are-effective-against-covid': faVirusCovidSlash,
  'cleaning-chemicals-used-are-effective-agaist-covid': faVirusCovidSlash,
  clock: faClock,
  close: faClose,
  'coffee-shop': faCoffeePot,
  comment: faComment,
  'common-areas-disinfected-daily': faSprayCan,
  'common-stationery-removed': faHandSparkles,
  concierge: faConciergeBell,
  'contact-book': faContactBook,
  'contactless-check-in': faSignalStream,
  'contactless-check-in-check-out': faSignalStream,
  'contactless-check-out': faSignalStream,
  'cooking-class': faHatChef,
  'couples-only': faPeoplePants,
  'credit-card': faCreditCard,
  cycling: faBicycle,
  'daily-housekeeping': faHandSparkles,
  darts: faBullseyeArrow,
  'delivered-food-covered-securely': faShieldVirus,
  'designated-smoking-area': faSmoking,
  diving: faMaskSnorkel,
  doorman: faConciergeBell,
  'dry-cleaning': faWashingMachine,
  'electric-vehicle-charging-station': faBolt,
  elevator: faElevator,
  'entertainment-staff': faUsers,
  'ethernet-internet-connection': faWifi,
  'ethernet-internet-connection-charges-apply': faWifi,
  'ethernet-internet-connection-complimentary': faWifi,
  'evening-entertainment': faPopcorn,
  'exclamation-triangle': faExclamationTriangle,
  'express-check-in': faBolt,
  'express-check-out': faBolt,
  'exterior-corridor': faBenchTree,
  eye: faEye,
  'eye-splash': faEyeSlash,
  'face-masks-available-for-guests': faMaskFace,
  'face-masks-on-staff': faHeadSideMask,
  facilities: faUniversalAccess,
  'facilities-for-disabled-guests': faUniversalAccess,
  'family-rooms': faFamily,
  'fax-services': faFax,
  'fire-extinguishers': faFireExtinguisher,
  fireplace: faFireplace,
  'fireplace-outdoor': faCampfire,
  'first-aid-kit': faKitMedical,
  'first-aid-kits': faKitMedical,
  fishing: faFishingRod,
  'fitness-center': faDumbbell,
  'food-can-be-delivered-for-in-room-dining': faPersonCarryBox,
  'food-delivery': faPersonCarryBox,
  'foot-bath': faBath,
  'foreign-currency-exchange': faCircleDollar,
  'front-desk': faConciergeBell,
  fruit: faAppleWhole,
  'game-room': faTeddyBear,
  garden: faFlowerTulip,
  generic: faCircle,
  'gift-shop': faGift,
  globe: faGlobe,
  'golf-course-on-site': faGolfFlagHole,
  'golf-course-within-3-5-km-2-mi': faGolfFlagHole,
  'golf-course-within-35-km-2-mi': faGolfFlagHole,
  'grocery-deliveries': faBasketShopping,
  'guest-accommodation-cleaning-can-be-cancelled': faDoNotEnter,
  'guest-accommodations-disinfected-between-stays': faSprayCan,
  'guest-accommodations-sealed-after-cleaning': faSeal,
  'guest-health-checks': faHandHoldingMedical,
  'guest-parking': faSquareParking,
  'guests-can-opt-out-of-daily-room-cleaning': faDoNotEnter,
  gym: faDumbbell,
  'hair-beauty-salon': faChairOffice,
  'hand-sanitizer-provided': faPumpMedical,
  'happy-hour': faMartiniGlassCitrus,
  heating: faHeat,
  hiking: faPersonHiking,
  honeymoon: faRingsWedding,
  'honeymoon-bridal-suite': faRingsWedding,
  'horseback-riding': faHorse,
  'hot-spring-bath': faHotTubPerson,
  'hot-tub': faHotTubPerson,
  'hygiene-certification': faFileCertificate,
  'hypoallergenic-rooms': faFeather,
  images: faImages,
  'indoor-play-area': faTeddyBear,
  infirmary: faHouseMedical,
  'info-circle': faInfoCircle,
  internet: faWifi,
  invoices: faFileInvoiceDollar,
  'ironing-service': faWashingMachine,
  karaoke: faMicrophoneStand,
  'key-card-or-motion-controlled-electricity': faCreditCardBlank,
  'kids-club': faTeddyBear,
  'kids-meals': faTv,
  'laundry-service': faWashingMachine,
  library: faBookOpenCover,
  'linens-towels-laundry-washed-per-local-authority-guidelines': faBlanket,
  'live-music-performance': faMicrophoneStand,
  'live-sports-events-broadcast': faTvMusic,
  'local-safety-protocols-followed': faShieldVirus,
  lock: faLock,
  'locker-rooms': faLock,
  lockers: faLock,
  lounge: faLoveseat,
  'low-bathroom-sink': faSink,
  'luggage-valet-service': faSuitcase,
  lunch: faSoup,
  magnify: faMagnifyingGlass,
  'map-marker-alt': faMapMarkerAlt,
  mask: faHeadSideMask,
  massage: faSpa,
  'massage-chair': faSpa,
  'meeting-rooms': faHandshake,
  'miniature-golf': faGolfBallTee,
  'minimarket-convenience-store': faBasketShopping,
  minus: faMinus,
  'mobile-app-for-room-service': faMobileScreenButton,
  'money-bill-wave': faMoneyBillWave,
  moon: faMoon,
  'movie-nights': faPopcorn,
  newspapers: faNewspaper,
  'nightclub-dj': faCompactDisc,
  'no-children-allowed': faBanSmoking,
  'non-smoking-rooms': faBanSmoking,
  'open-air-bath': faHotTubPerson,
  'outdoor-fireplace': faCampfire,
  'outdoor-furniture': faBenchTree,
  'outdoor-play-equipment': faBaseballBatBall,
  pencil: faPencil,
  'personal-trainer': faDumbbell,
  'pet-friendly': faPaw,
  'photocopying-services': faPrint,
  'physical-distancing-in-dining-areas': faPeopleArrows,
  'physical-distancing-rules': faPeopleArrows,
  'picnic-area': faTablePicnic,
  playground: faBasketballHoop,
  'pool-beach-towels': faBlanket,
  'portable-wi-fi-device-rental': faRouter,
  'postal-service': faEnvelope,
  'prepared-lunches': faBowlHot,
  printer: faPrint,
  'private-check-in': faAddressCard,
  'private-check-in-check-out': faAddressCard,
  'private-check-out': faAddressCard,
  'property-cleaned-by-professional-cleaning-companies': faHandSparkles,
  'property-has-wheelchair-access': faWheelchair,
  'public-transit-tickets': faTicket,
  'racquetball-squash': faRacquet,
  'raised-toilet': faToilet,
  'refillable-water-stations': faGlassWaterDroplet,
  refresh: faRefresh,
  restaurant: faUtensils,
  'restaurant-halal': faFlatbreadStuffed,
  'restaurant-kosher': faPotFood,
  'room-service': faBellConcierge,
  'room-service-24-hours': faBellConcierge,
  'safe-deposit-boxes-at-front-desk': faVault,
  'safety-deposit-box': faVault,
  'sanitized-tableware': faHandSparkles,
  sauna: faHeat,
  'screens-between-staff-guests-where-needed': faPeopleArrows,
  'security-alarm': faSirenOn,
  'self-service-laundry': faWashingMachine,
  'shared-kitchen': faOven,
  'shared-lounge-tv-area': faTv,
  'shield-check': faShieldCheck,
  shoeshine: faSparkles,
  'shops-on-site': faShop,
  shrine: faHandsPraying,
  'shuttle-service': faVanShuttle,
  'single-use-plastics-removed': faLeafHeart,
  'ski-equipment-rental': faPersonSkiing,
  'ski-school': faPersonSkiing,
  skiing: faPersonSkiing,
  'smoke-alarms': faSensorFire,
  'smoke-free-property': faBanSmoking,
  'snack-bar': faBurgerFries,
  snorkeling: faMaskSnorkel,
  solarium: faSun,
  'soundproof-rooms': faVolumeSlash,
  spa: faSpa,
  'special-diet': faSalad,
  'special-diet-meals-on-request': faSalad,
  'stand-up-comedy': faMicrophoneStand,
  star: faStar,
  'steam-room': faHeat,
  sterilizing: faSprayCan,
  'sterilizing-equipment': faSprayCan,
  strollers: faBabyCarriage,
  'suit-trouser-press': faClothesHanger,
  'sun-deck': faSunCloud,
  'surfing-lessons': faWaterLadder,
  'swimming-pool': faPersonSwimming,
  'table-tennis-ping-pong': faTableTennisPaddleBall,
  tag: faTag,
  taxi: faTaxi,
  'taxi-service': faTaxi,
  'temperature-check-for-guests-and-staff': faTemperatureHigh,
  'temporary-art-galleries': faPalette,
  'tennis-court': faTennisBall,
  terrace: faBenchTree,
  'theme-park': faRollerCoaster,
  'themed-dinners': faPanFood,
  'thermometers-for-guests': faThermometer,
  'ticketing-service': faTicket,
  'toilet-with-grab-rails': faUniversalAccess,
  'tour-assistance': faPersonSign,
  tours: faMap,
  'towels-changed-upon-request': faBlanket,
  'trash-can': faTrashCan,
  'turkish-steam-bath': faHeat,
  university: faUniversity,
  user: faUser,
  users: faUsers,
  'valet-parking': faCarGarage,
  'valet-service': faCarGarage,
  'vending-machine-drinks': faCupStrawSwoosh,
  'vending-machine-snacks': faBurrito,
  'vending-machines-contents-unspecified': faBurrito,
  'vip-room-facilities': faStar,
  'visual-aids-braille': faBraille,
  'visual-aids-tactile-signs': faHand,
  'walking-tours': faMap,
  'warn-circle': faCircleExclamation,
  'water-park': faRollerCoaster,
  'water-sports-equipment-rental': faMaskSnorkel,
  'water-sports-motorized': faPersonSwimming,
  'water-sports-non-motorized': faPersonSwimming,
  waterslide: faRollerCoaster,
  'welcome-drink': faChampagneGlass,
  wifi: faWifi,
  'wifi-charges-apply': faWifi,
  'wifi-complimentary': faWifi,
  windsurfing: faWaterLadder,
  'wine-champagne': faChampagneGlass,
  'wireless-internet': faWifi,
  yoga: faSpa,
} as const;

export const getFAIcon = (name: FaIconName): IconDefinition =>
  FA_ICONS[name] || FA_ICONS.check;
